import { safeDivide, summarizeMetricsArray } from "../math";
import { type InsightsMetrics, type StatsItem } from "../models";

/*

Average value is used for BarChartComponent

Computation:
lens_ctr(t₁) + lens_ctr(t₂) + ...  / # items in the set

Since 𝛴 (lens_ctr) does not have much meaning on its own,
we don't compute it as totalValue to discourage its usage

This is this one place we do this computation

*/
export const mapCTRAverageValue = (computedMetric: InsightsMetrics<StatsItem>): InsightsMetrics<StatsItem> => ({
    ...computedMetric,
    averageValue: safeDivide(summarizeMetricsArray(computedMetric.stats), computedMetric.stats.length),
});
